import DatabaseModel from './DatabaseModel.js';

// Agente IA de planificación (F1) — panel de doble control (servicio→residuales) + aprobar/rechazar.
// Lectura del dato materializado por el motor; escritura solo aprobar/rechazar (gateadas por flag en back).
// El solver NO se toca. cached=false → siempre fresco.
var AgenteAprendizaje = Object.create(DatabaseModel);

AgenteAprendizaje.model = 'planificacion/agente';

AgenteAprendizaje.panel = function() {
    var self = this;
    return self.sendRequest({ url: self.server_movilidad + self.prefix + self.model + '/panel', method: 'GET', data: {} }, false);
};

AgenteAprendizaje.estado = function() {
    var self = this;
    return self.sendRequest({ url: self.server_movilidad + self.prefix + self.model + '/estado', method: 'GET', data: {} }, false);
};

AgenteAprendizaje.ajustes = function() {
    var self = this;
    return self.sendRequest({ url: self.server_movilidad + self.prefix + self.model + '/ajustes', method: 'GET', data: {} }, false);
};

AgenteAprendizaje.informeSemanal = function(topN) {
    var self = this;
    var url = self.server_movilidad + self.prefix + self.model + '/informe-semanal';
    if (topN) { url += '?topN=' + encodeURIComponent(topN); }
    return self.sendRequest({ url: url, method: 'GET', data: {} }, false);
};

AgenteAprendizaje.guardianOeb = function(anio, mes) {
    var self = this;
    var url = self.server_movilidad + self.prefix + self.model + '/guardian-oeb';
    var qs = [];
    if (anio) { qs.push('anio=' + encodeURIComponent(anio)); }
    if (mes) { qs.push('mes=' + encodeURIComponent(mes)); }
    if (qs.length) { url += '?' + qs.join('&'); }
    return self.sendRequest({ url: url, method: 'GET', data: {} }, false);
};

AgenteAprendizaje.aprobar = function(patternId) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/aprobar?patternId=' + encodeURIComponent(patternId),
        method: 'POST', data: {}
    }, false);
};

AgenteAprendizaje.rechazar = function(patternId, motivo) {
    var self = this;
    var url = self.server_movilidad + self.prefix + self.model + '/rechazar?patternId=' + encodeURIComponent(patternId);
    if (motivo) { url += '&motivo=' + encodeURIComponent(motivo); }
    return self.sendRequest({ url: url, method: 'POST', data: {} }, false);
};

export default AgenteAprendizaje;
